import updateImage from './updateImage';
import updateTitleDescription from './updateTitleDescription';
import updateUrl from './updateUrl';

/**
 *
 * @param {string=} type
 * @param {string=} title
 * @param {string=} description
 * @param {Object=} image
 * @param {boolean=} isStaticImagesPublished
 * @param {boolean=} isOriginalImage
 */
const updateMetaTags = ({
  type,
  title,
  description,
  image,
  isStaticImagesPublished,
  isOriginalImage,
}) => {
  updateUrl(type);

  if (title || description) updateTitleDescription({ title, description });
  if (image) updateImage({ image, isStaticImagesPublished, isOriginalImage });
};

export default updateMetaTags;
